import { WishlistProvider } from "./provider.js";
import { useWishlistId } from "./hooks/hooks/use-wishlist-id.js";
export {
  WishlistProvider,
  useWishlistId
};
//# sourceMappingURL=index.js.map
